import ProductPage from "../../components/ProductPage";
import { corporateFDData } from "../../data/productsData";
export default function CorporateFD() { return <ProductPage data={corporateFDData} />; }